/** Dias da semana  */
export interface DiaSemana {
    dia: number;
    nome: string;
}

export const diaSemanaDomingo: DiaSemana = {dia: 0, nome: 'Domingo'};
export const diaSemanaSegundaFeira: DiaSemana = {dia: 1, nome: 'Segunda-Feira'};
export const diaSemanaTercaFeira: DiaSemana = {dia: 2, nome: 'Terça-Feira'};
export const diaSemanaQuartaFeira: DiaSemana = {dia: 3, nome: 'Quarta-Feira'};
export const diaSemanaQuintaFeira: DiaSemana = {dia: 4, nome: 'Quinta-Feira'};
export const diaSemanaSextaFeira: DiaSemana = {dia: 5, nome: 'Sexta-Feira'};
export const diaSemanaSabado: DiaSemana = {dia: 6, nome: 'Sábado'};


export const diasSemanas: DiaSemana[] = [
    diaSemanaDomingo,
    diaSemanaSegundaFeira,
    diaSemanaTercaFeira,
    diaSemanaQuartaFeira,
    diaSemanaQuintaFeira,
    diaSemanaSextaFeira,
    diaSemanaSabado
];

/** Verifica se o dia da semana é Domingo */
export function isDiaSemanaDomingo(diaSemana: number): boolean {
    return diaSemana === diaSemanaDomingo.dia;
}

/** Verifica se o dia da semana é Segunda-Feira */
export function isDiaSemanaSegundaFeira(diaSemana: number): boolean {
    return diaSemana === diaSemanaSegundaFeira.dia;
}

/** Verifica se o dia da semana é Terça-Feira */
export function isDiaSemanaTercaFeira(diaSemana: number): boolean {
    return diaSemana === diaSemanaTercaFeira.dia;
}

/** Verifica se o dia da semana é Quarta-Feira */
export function isDiaSemanaQuartaFeira(diaSemana: number): boolean {
    return diaSemana === diaSemanaQuartaFeira.dia;
}

/** Verifica se o dia da semana é Quinta-Feira */
export function isDiaSemanaQuintaFeira(diaSemana: number): boolean {
    return diaSemana === diaSemanaQuintaFeira.dia;
}

/** Verifica se o dia da semana é Sexta-Feira */
export function isDiaSemanaSextaFeira(diaSemana: number): boolean {
    return diaSemana === diaSemanaSextaFeira.dia;
}

/** Verifica se o dia da semana é Sábado */
export function isDiaSemanaSabado(diaSemana: number): boolean {
    return diaSemana === diaSemanaSabado.dia;
}
